(function () {
  /**
   * @typedef UserVote
   * @type {object}
   * @property {string} country
   * @property {number} id
   * @property {number} time
   */

  /**
   * @typedef UserDataObject
   * @type {object}
   * @property {boolean} hasEverVoted
   * @property {boolean} hasUsedDoubleClick
   * @property {boolean} hasUsedSwipe
   * @property {UserVote[]} votes
   * @property {number[]} uploadedLanes
   */

  /**
   * @type {string}
   */
  var storageKey = 'worst-cycling-lane-user';

  /**
   * @returns {UserDataObject}
   */
  function createUserDataObject() {
    return {
      hasEverVoted: false,
      hasUsedDoubleClick: false,
      hasUsedSwipe: false,
      votes: [],
      uploadedLanes: [],
    };
  }

  /**
   * @param {string} country
   * @param {number} laneId
   * @returns {UserVote}
   */
  function createVote(country, laneId) {
    return {
      country: country,
      id: laneId,
      time: Math.round(Date.now() / 1000),
    };
  }

  /**
   * @returns {UserDataObject}
   */
  function loadData() {
    var userData = window.ysStorage.Get(storageKey);
    var data = createUserDataObject();

    if (!userData || typeof userData !== 'object') {
      return data;
    }

    // We are using shortcut properties to reduce cookie size
    if (typeof userData.hasEverVoted !== 'undefined') {
      data.hasEverVoted = userData.hasEverVoted === true;
    }

    if (typeof userData.hasUsedDoubleClick !== 'undefined') {
      data.hasUsedDoubleClick = userData.hasUsedDoubleClick === true;
    }

    if (typeof userData.hasUsedSwipe !== 'undefined') {
      data.hasUsedSwipe = userData.hasUsedSwipe === true;
    }

    if (
      userData.votes &&
      typeof userData.votes === 'object' &&
      userData.votes.length > 0
    ) {
      for (var i = 0; i < userData.votes.length; i++) {
        var element = userData.votes[i];
        if (
          element.country &&
          typeof element.country === 'string' &&
          element.id &&
          typeof element.id === 'number' &&
          element.time &&
          typeof element.time === 'number'
        ) {
          data.votes.push(element);
        }
      }
    }

    if (
      userData.uploadedLanes &&
      typeof userData.uploadedLanes === 'object' &&
      userData.uploadedLanes.length > 0
    ) {
      for (
        var laneIndex = 0;
        laneIndex < userData.uploadedLanes.length;
        laneIndex++
      ) {
        data.uploadedLanes.push(userData.uploadedLanes[laneIndex]);
      }
    }

    return data;
  }

  this.UserDataService = function (plugin) {
    /**
     * @type {UserDataObject}
     */
    this.data = loadData();
    this.plugin = plugin;

    this.save = function () {
      window.ysStorage.Set(storageKey, this.data);
    }.bind(this);
  };

  /**
   * Remove votes older than today
   */
  this.UserDataService.prototype.CleanupVotes = function () {
    var today = Math.floor(Date.now() / 1000 / 8600);
    this.data.votes = this.data.votes.filter(function (vote) {
      var dayOfVote = Math.floor(vote.time / 8600);
      return dayOfVote >= today;
    });
    this.save();
  };

  /**
   * @returns {boolean}
   */
  this.UserDataService.prototype.HasEverVoted = function () {
    return this.data.hasEverVoted === true;
  };

  /**
   * @returns {boolean}
   */
  this.UserDataService.prototype.HasUsedDoubleClick = function () {
    return this.data.hasUsedDoubleClick === true;
  };

  /**
   * @returns {boolean}
   */
  this.UserDataService.prototype.SetUsedDoubleClick = function () {
    this.data.hasUsedDoubleClick = true;
    this.save();
  };

  /**
   * @returns {boolean}
   */
  this.UserDataService.prototype.HasUsedSwipe = function () {
    return this.data.hasUsedSwipe === true;
  };

  /**
   * @returns {boolean}
   */
  this.UserDataService.prototype.SetUsedSwipe = function () {
    this.data.hasUsedSwipe = true;
    this.save();
  };

  /**
   * Add vote status to the storage
   * @param {string} country
   * @param {number} id
   * @throws {Error}
   */
  this.UserDataService.prototype.AddVote = function (country, id) {
    var laneId = parseInt(id, 10);
    if (!laneId) {
      throw new Error('lane.invalidId');
    }
    this.CleanupVotes();
    this.data.votes.push(createVote(country, laneId));
    this.data.hasEverVoted = true;
    this.save();
  };

  /**
   * Add lane ID to uploaded Lanes
   * @param {number} id
   * @throws {Error}
   */
  this.UserDataService.prototype.AddUploadedLane = function (id) {
    var laneId = parseInt(id, 10);
    if (!laneId) {
      throw new Error('lane.invalidId');
    }
    if (this.data.uploadedLanes.indexOf(laneId) < 0) {
      this.data.uploadedLanes.push(laneId);
    }
    this.save();
  };

  /**
   * Check whether the user has uploaded lane by ID
   * @param {number} id
   */
  this.UserDataService.prototype.HasUploadedLane = function (id) {
    var laneId = parseInt(id, 10);
    if (!laneId) {
      throw new Error('lane.invalidId');
    }

    return this.data.uploadedLanes.indexOf(laneId) >= 0;
  };

  /**
   * Remove vote from the storage
   * @param {number} id
   * @throws {Error}
   */
  this.UserDataService.prototype.RemoveVote = function (id) {
    var laneId = parseInt(id, 10);
    if (!laneId) {
      throw new Error('lane.invalidId');
    }
    this.CleanupVotes();
    this.data.votes = this.data.votes.filter(function (vote) {
      return vote.id !== laneId;
    });
    this.save();
  };

  /**
   * @param {string} country
   * @return {UserVote[]|null}
   */
  this.UserDataService.prototype.GetVotesForCountry = function (country) {
    var countryVotes = [];
    for (var voteIndex = 0; voteIndex < this.data.votes.length; voteIndex++) {
      var vote = this.data.votes[voteIndex];
      if (vote.country === country) {
        countryVotes.push(vote);
      }
    }

    return countryVotes.length > 0 ? countryVotes : null;
  };
  /**
   * @return {number[]}
   */
  this.UserDataService.prototype.GetUploadedLanes = function () {
    return this.data.uploadedLanes;
  };

  /**
   * @param {number} id
   */
  this.UserDataService.prototype.HasVotedForLane = function (id) {
    var laneId = parseInt(id, 10);
    for (var voteIndex = 0; voteIndex < this.data.votes.length; voteIndex++) {
      var vote = this.data.votes[voteIndex];
      if (vote.id === laneId) {
        return true;
      }
    }

    return false;
  };
}).bind(window.WorstCyclingLane)();
